// project imports

export const initialState = {};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
        // case actionTypes.GET_ENABLE_ISSUE:
        //     return {
        //         ...state,
        //         enableIssue: action.data.value
        //     };
        // case actionTypes.SET_ENABLE_ISSUE:
        //     return {
        //         ...state,
        //         enableIssue: action.data.value
        //     };
        default:
            return state;
    }
};

export default settingsReducer;
